import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ACTIVE_SESSION_KEY = 'dbpro_active_session';

export const readActiveSession = () => {
  try {
    const raw = localStorage.getItem(ACTIVE_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearActiveSession = () => {
  try {
    localStorage.removeItem(ACTIVE_SESSION_KEY);
  } catch {
    // ignore
  }
};

// Unified save path: refresh token → POST /api/sessions → queue to dbpro_failed_sessions on failure
export const saveSessionWithRetry = async (session) => {
  let token = localStorage.getItem('dbpro_session_token');

  try {
    if (token) {
      const refreshResponse = await axios.post(`${API}/auth/refresh`, {}, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (refreshResponse.data?.session_token) {
        token = refreshResponse.data.session_token;
        localStorage.setItem('dbpro_session_token', token);
      }
    }
  } catch (refreshErr) {
    console.warn('Token refresh failed, proceeding with existing token:', refreshErr);
  }

  try {
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    await axios.post(`${API}/sessions`, session, { headers });
    return true;
  } catch (err) {
    console.error('Error saving session:', err);
    const failedSessions = JSON.parse(localStorage.getItem('dbpro_failed_sessions') || '[]');
    failedSessions.push({
      ...session,
      failed_at: new Date().toISOString()
    });
    localStorage.setItem('dbpro_failed_sessions', JSON.stringify(failedSessions));
    return false;
  }
};
